import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import csvHelper from '../reports/importjsontocsv';

Vue.component("downloadExcel", JsonExcel);

import {
	Validator
} from 'vee-validate'

export default {
	name: 'Packingreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader
	},
	data: function () {
		return {
			isLoadingforxls: false,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalRows: 0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			listInventorySyncData: [],
			listInventorySyncDataCsv: [],
			listWarehouseData: [],
			listPackingReportDataCsv: [],
			listuserData: [],
			csvFields: [],
			datenow: '',
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			transcationfromdate: '',
			transactiontodate: '',
			formattedDate: '',
			Transmissiontype: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',

			client: '',
			ClientErr: '',
			UidErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			UILflag: false,
			user_type: '',
			EmailUID: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			userid: '',
			recordLimit: 0,
			limitExeed: false,
			clientproductid: '',
			warehousename: ''
		}
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('inventoryLog.inventorySyncLogFileName'),
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.warehousename = userdetail.fullname


				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	},
	methods: {

		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getDataTransmissinreportDataForXls(3)
			}
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);

		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;


		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;

		// 		if (this.user_type != 'warehouse_user') {
		// 			this.totalRows = 0
		// 			this.listInventorySyncData = []
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';

		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {

		// 			if (this.warehouseid && this.clientid);

		// 		}
		// 	}

		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {


		// 	this.warehouseid = this.warehouse;
		// 	this.warehousename = ''
		// 	this.listWarehouseData.filter(item => {
		// 		if (item.warehouseid == this.warehouseid) {
		// 			return this.warehousename = item.warehousename
		// 		}
		// 	})
		// 	console.log(this.warehouse, ";lkjbjkllkjnb")
		// 	this.pageno = this.totalPage = 0;
		// 	this.listInventorySyncData = [];
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {

		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getDataTransmissinreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getDataTransmissinreportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getDataTransmissinreportData(2);
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 23:59:00');
		},
		isNumeric: function (n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		//to get Stock list
		getDataTransmissinreportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			this.ClientErr = '';
			this.UidErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listInventorySyncData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listInventorySyncData = [];
				return false;
			}

			this.isLoading = true;
			if (this.transcationfromdate == '') {
				packingfr_date = '';
			} else {

				packingfr_date = this.dateFormat(this.transcationfromdate)
			}

			if (this.transactiontodate == '') {
				packingto_date = '';
			} else {
				packingto_date = this.dateFormat2(this.transactiontodate)
			}
			if (this.Transmissiontype == 'racks') {
				this.client = '';
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: packingfr_date,
				todate: packingto_date,
				clientproductid: this.clientproductid.trim(),
				clientid: this.clientid,
				csvData: csvCheck,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'inventorysynclogreport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					console.log(result.data, "++++++++++++++++++++++++++")
					if (csvCheck == 1) {
						if (result.data.count > 0) {
							this.show = true;
							this.download = false;
							this.csvFields = {
                                'count' : this.$t('importCsv.count'),
								'clientproductid': this.$t('product.clientProductId'),
								'currentstock': this.$t('common.stock'),
								'currentdate': this.$t('inventoryLog.syncingDateTime'), 
								'warehousename': this.$t('common.warehouse'),



							};
							var dateFilder = [];
							var skipFilter = ['transcationdate', 'productid', 'warehouseid'];
							this.listInventorySyncDataCsv = result.data.data;
							this.listInventorySyncDataCsv.map(item => {
								return item.warehousename = this.warehousename
							})
							csvHelper.data.jsonToCSV(this.$t('inventoryLog.inventorySyncLogFileName'), this.listInventorySyncDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
							//	this.jsonToCSV('', this.listInventorySyncDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg);
							}
						}
					} else {
						this.listInventorySyncData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0
						} else {
							this.totalRows = Number(result.data.count)
							this.resultCount = this.totalRows
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}

					// }
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})

		},
		getDataTransmissinreportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			this.ClientErr = '';
			this.UidErr = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 100,
				fromdate: packingfr_date,
				todate: packingto_date,
				clientproductid: this.clientproductid.trim(),
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				csvData: csvCheck,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'inventorysynclogreport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.count > 0) {
							this.listReportDataforxls = [];
							this.listReportDataforxls.push(this.warehousename)
							this.csvFieldsForXls[this.$t('importCsv.count')] = 'count';
							this.csvFieldsForXls[this.$t('product.clientProductId')]='clientproductid';
							this.csvFieldsForXls[this.$t('common.stock')]='currentstock';
							this.csvFieldsForXls[this.$t('inventoryLog.syncingDateTime')]='currentdate';
							this.csvFieldsForXls[this.$t('common.warehouse')]='warehousename';

							this.listReportDataforxls = result.data.data;
							this.listReportDataforxls.map(item => {
								return item.warehousename = this.warehousename
							})

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				},
					error => {
						console.error(error)
					})

		},
		//to reset search form
		resetForm() {
			this.show = false;
			this.download = true;
			this.totalRows = 0
			this.clientproductid = ''
			this.transcationfromdate = '';
			this.transactiontodate = '';
			this.Transmissiontype = '';
			this.listInventorySyncData = [];
			this.pageno = this.totalPage = 0;
			this.searchFlag = false;

			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//to paginate  GRC List
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getDataTransmissinreportData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getDataTransmissinreportData()
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/inventorysyncingreport/inventorysyncingreport.component.js